export default theme => ({
    control: styles => ({
        /*':hover': {
            background: theme.palette.primaryHover,
        },
        ':active': {
            background: theme.palette.primaryHover,
        },*/
        background: theme.background.base,
        fontFamily: theme.typography.fontFamily.sansSerif,
        fontWeight: theme.typography.fontWeight.base,
        fontSize: 14,
        borderRadius: theme.border.primaryRadius,
        alignItems: styles.alignItems,
        boxSizing: styles.boxSizing,
        cursor: 'pointer',
        letterSpacing: 0,
        display: styles.display,
        flexWrap: styles.flexWrap,
        justifyContent: styles.justifyContent,
        minHeight: styles.minHeight,
        outline: styles.outline,
        position: styles.position,
        transition: styles.transition,
    }),
    option: (styles, state) => ({
        ...styles,
        whiteSpace: 'pre-wrap',
        cursor: 'pointer',
        color: state.isSelected
            ? theme.palette.primarySelected
            : theme.palette.primaryText,
        background: 'transparent',
        ':hover': {
            background: theme.palette.primaryHover,
        },
        fontFamily: theme.typography.fontFamily.sansSerif,
        fontWeight: state.isSelected
            ? theme.typography.fontWeight.bold
            : theme.typography.fontWeight.base,
        fontSize: 14,
        ...(state.isDisabled && ({
            color: theme.palette.primaryTextDisabled,
            cursor: 'default',
            pointerEvents: 'none',
        })),
    }),
});
